<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {},
        data() {
            return {}
        },
        methods: {
            handleCurrentChange(){},
            ...mapActions('subsidies/select',{
                change: 'change'
            }),
        },
        computed: {
            ...mapState('subsidies/select/list', {
                items: 'items',
            }),
            ...mapState('subsidies/select',{
                tab: 'tab',
            }),
        },
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="table">
        <el-table
                :data="items"
                sortable
                border
                stripe
                highlight-current-row
                @current-change="change"
                :height="350"
                v-if="tab==='list'"
                style="width: 100%">
            <el-table-column
                    label="Номер"
                    prop="Number"
                    fixed="left"
                    :width="120"
                    sortable>
            </el-table-column>
            <el-table-column
                    label="Дата выдачи"
                    prop="IssueDate.Milliseconds"
                    :width="100"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.IssueDate ? scope.row.IssueDate.Serialized : ''}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Дата начала действия"
                    prop="StartDate.Milliseconds"
                    :width="100"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.StartDate ? scope.row.StartDate.Serialized : ''}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Дата окончания действия"
                    prop="EndDate.Milliseconds"
                    :width="100"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.EndDate ? scope.row.EndDate.Serialized : ''}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Покупатель"
                    prop="Buyer"
                    :width="150"
                    sortable>
            </el-table-column>
            <el-table-column
                    label="Сумма"
                    prop="Sum"
                    :width="100"
                    class-name="table__price"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.Sum | price(0)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Доступно для оплаты"
                    prop="AvailableSum"
                    class-name="table__price"
                    :width="100"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.AvailableSum | price(0)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Валюта"
                    prop="CurrencyIso"
                    sortable>
            </el-table-column>
            <el-table-column
                    label="Оплачен"
                    :width="100"
                    prop="IsPayed"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.IsPayed ? 'Оплачен' : 'Не оплачен'}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Погашен"
                    prop="IsUsed"
                    :width="100"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.IsPayed ? (scope.row.IsUsed ? 'Погашен' : 'Активен') : 'Нет'}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Тип"
                    prop="Type"
                    :width="120"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.Type === 1 ? 'Одноразовый' : 'Многоразовый'}}
                </template>
            </el-table-column>
            <el-table-column
                    label="Фирма"
                    prop="OwnerLegalEntityName"
                    :width="170"
                    sortable>
            </el-table-column>
        </el-table>
    </div>
</template>
<style lang="scss">
</style>
